import { useTranslations } from '@vocab/react';
import { Column, Columns, Divider, Text } from 'braid-design-system';

import translations from '../.vocab';

export const SeekAiSectionDivider = () => {
  const { t } = useTranslations(translations);

  return (
    <Columns space="small" alignY="center">
      <Column>
        <Divider />
      </Column>
      <Column width="content">
        <Text align="center" size="xsmall" tone="secondary">
          {t('seek-ai-or')}
        </Text>
      </Column>
      <Column>
        <Divider />
      </Column>
    </Columns>
  );
};
